import { apiClient } from './client';
import { downloadPdfBlob } from '../utils/downloadPdf';
import {
  ProductManual,
  ProductManualAttachment,
  ProductManualPayload,
} from '../types/productManual';

export async function fetchProductManuals(
  keyword?: string,
  contractId?: number | null
): Promise<ProductManual[]> {
  const params: Record<string, string | number> = {};
  if (keyword?.trim()) params.q = keyword.trim();
  if (contractId != null) params.contractId = contractId;
  const { data } = await apiClient.get<ProductManual[]>('/product-manuals', {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export async function fetchProductManual(productManualId: number): Promise<ProductManual> {
  const { data } = await apiClient.get<ProductManual>(`/product-manuals/${productManualId}`);
  return data;
}

export async function createProductManual(payload: ProductManualPayload): Promise<ProductManual> {
  const { data } = await apiClient.post<ProductManual>('/product-manuals', payload);
  return data;
}

export async function updateProductManual(
  productManualId: number,
  payload: ProductManualPayload
): Promise<ProductManual> {
  const { data } = await apiClient.patch<ProductManual>(
    `/product-manuals/${productManualId}`,
    payload
  );
  return data;
}

export async function deleteProductManual(productManualId: number): Promise<void> {
  await apiClient.delete(`/product-manuals/${productManualId}`);
}

export async function approveProductManual(productManualId: number): Promise<ProductManual> {
  const { data } = await apiClient.post<ProductManual>(`/product-manuals/${productManualId}/approve`);
  return data;
}

export async function revokeProductManual(productManualId: number): Promise<ProductManual> {
  const { data } = await apiClient.post<ProductManual>(`/product-manuals/${productManualId}/revoke`);
  return data;
}

export async function uploadProductManualAttachments(
  productManualId: number,
  files: File[]
): Promise<ProductManualAttachment[]> {
  const form = new FormData();
  files.forEach((file) => form.append('files', file));
  const { data } = await apiClient.post<ProductManualAttachment[]>(
    `/product-manuals/${productManualId}/attachments`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function deleteProductManualAttachment(
  productManualId: number,
  attachmentId: number
): Promise<void> {
  await apiClient.delete(`/product-manuals/${productManualId}/attachments/${attachmentId}`);
}

export async function downloadProductManualAttachment(
  productManualId: number,
  attachmentId: number,
  fileName: string
): Promise<void> {
  const { data } = await apiClient.get<Blob>(
    `/product-manuals/${productManualId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}


export async function downloadProductManualPdf(
  productManualId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/product-manuals/${productManualId}/pdf`,
    fileName || `제품설명서_${productManualId}.pdf`
  );
}
